import DashboardLayout from "../components/layouts/DashboardLayout/DashboardLayout";

export default function VehiclesPage() {

    return (

        <DashboardLayout
            pageTitle="Mon parking"
        >

            <div style={{ padding: "30px" }}>

                <h1>Véhicules</h1>

                <p>

                    Cette page sera développée prochainement.

                </p>

            </div>

        </DashboardLayout>

    );

}